import '../scss/bootstrap.scss';

import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';

/*
 * Multilevel dropdowns on navbar
 */
const CLASS_NAME = 'has-child-dropdown-show';
Dropdown.prototype.toggle = (function (_orginal) {
	return function () {
		document.querySelectorAll('.' + CLASS_NAME).forEach(function (e) {
			e.classList.remove(CLASS_NAME);
		});
		let dd = this._element.closest('.dropdown').parentNode.closest('.dropdown');
		for (; dd && dd !== document; dd = dd.parentNode.closest('.dropdown')) {
			dd.classList.add(CLASS_NAME);
		}
		return _orginal.call(this);
	};
})(Dropdown.prototype.toggle);

document.querySelectorAll('.dropdown').forEach(function (dd) {
	dd.addEventListener('hide.bs.dropdown', function (e) {
		if (this.classList.contains(CLASS_NAME)) {
			this.classList.remove(CLASS_NAME);
			e.preventDefault();
		}
		e.stopPropagation();
	});
});

/*
 * Navbar dropdown on hover
 */
const navbarToggler = document.querySelector('.navbar-toggler');

if (window.getComputedStyle(navbarToggler).display === 'none') {
	document.querySelectorAll('.dropdown-hover, .dropdown-hover-all .dropdown').forEach(function (dd) {
		dd.addEventListener('mouseenter', function (e) {
			let toggle = e.target.querySelector(':scope>[data-bs-toggle="dropdown"]');
			if (!toggle.classList.contains('show')) {
				Dropdown.getOrCreateInstance(toggle).toggle();
				dd.classList.add(CLASS_NAME);
				Dropdown.clearMenus();
			}
		});
		dd.addEventListener('mouseleave', function (e) {
			let toggle = e.target.querySelector(':scope>[data-bs-toggle="dropdown"]');
			if (toggle.classList.contains('show')) {
				Dropdown.getOrCreateInstance(toggle).toggle();
			}
		});
	});
}
